export const copyToClipboard = async (generateClipboardString: () => Promise<string>) => {
  if (/^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    const clipboardItem = new ClipboardItem({
      // eslint-disable-next-line @typescript-eslint/naming-convention -- key is defined by ClipboardItem API
      'text/plain': generateClipboardString().then(async (result: string) =>
        // eslint-disable-next-line promise/no-return-wrap, unicorn/no-useless-promise-resolve-reject -- iOS ClipboardItem API defines return type as Promise
        Promise.resolve(new Blob([result])),
      ),
    });
    await navigator.clipboard.write([clipboardItem]);
  } else {
    const result = await generateClipboardString();
    await navigator.clipboard.writeText(result);
  }
};
